let Plugin_Zadost = {

    progressInterval: null,

    init: function () {

        let section = $('#idSection');
        if (!section.length || 103 !== parseInt(section.val())) {
            return;
        }

        $(document)
            .on('modal.button.miniform.close.pre', function () {

                // změna stavu žádosti
                let panel = $('#modal-request-change-state');
                if (panel.length) {
                    let buttonSave = $(':button[name="saveContinue"]');
                    if (buttonSave.length) {
                        const cisloKontroly = $("#evidencnicislokontroly");
                        const cisloKontrolyModal = $("#modal-evidencnicislokontroly");
                        if (cisloKontroly.length
                            && cisloKontrolyModal.length
                            && cisloKontrolyModal.val()
                        ) {
                            cisloKontroly.val(cisloKontrolyModal.val());
                        }

                        $(document).off('ajaxStop');
                        buttonSave
                            .attr('name', 'saveAndChangeState')
                            .trigger('click');
                    }
                    return;
                }

                // změna žadatele a doplnění údajů
                panel = $('#modal-request-change-user');
                if (panel.length) {

                    let _ch = $('#_ch');
                    let modalForm = $('#miniform');
                    if (!_ch.length) {
                        return;
                    }

                    var user = modalForm.find('#modal-uzivatel');
                    var update = modalForm.find(':hidden[name="aktualizovatudaje"]');

                    if (!user.length || !user.val() || !update.length) {
                        Lemo_Alert.addDanger('Nebyl zadán žadatel, změna nebyla provedena', 'changeRequestUserEmptyError');
                        return;
                    }

                    var url = window.location.protocol + '//' + window.location.host;
                    url += '/plugin/PluginZadost/ajaxChangeUser';

                    $.ajax({
                        type: 'post',
                        url: url,
                        dataType: "json",
                        global: false,
                        data: {'_ch': _ch.val()},
                        beforeSend: function () {
                            Lemo_Alert.closeAll();
                            Lemo_Alert.addInfo('Aktualizuji žadatele ...', 'changeRequestUserBeforeSend');
                        },
                        complete: function () {
                            Lemo_Alert.closeById('changeRequestUserBeforeSend');
                        },
                        success: function (r) {

                            if (r.hasOwnProperty('messages')) {
                                Lemo_Alert.addMany(r.messages);
                            }

                            if (r.hasOwnProperty('status') && false === r.status) {
                                Lemo_Alert.addDanger('Aktualizace žadatele se nezdařila', 'updateRequestUserError');
                                return;
                            }

                            var data = r.data;
                            if (data.hasOwnProperty('idUser') && data['idUser'] && data.hasOwnProperty('username') && data['username']) {
                                $('#uzivatel').val(data['idUser']);
                                $('#uzivatelAutocomplete').val(data['username']);
                            }

                            if (data.hasOwnProperty('bankovniucet')) {
                                var element = $('#bankovniucet');
                                if (element.length) {
                                    element.val(data['bankovniucet']);
                                }
                            }

                            if (data.hasOwnProperty('subject')) {
                                $.each(data['subject'], function (name, value) {
                                    var element = $('#' + name);
                                    if (element.length) {
                                        if (true === element.is('select') && value.hasOwnProperty('id')) {
                                            element.children('[value="' + value.id + '"]').attr('selected', true).prop('selected', true);
                                        } else {
                                            element.val(value);
                                        }
                                    }
                                });

                                // reload a refresh
                                DynaCore_Item.miniformReload(6, 54);
                                DynaCore_Item.miniformReload(5, 55);
                                DynaCore_Item.refreshAction();
                            }
                        },
                        error: function () {
                            Lemo_Alert.addDanger('Aktualizace žadatele selhala ...', 'updateRequestUserError');
                        }
                    });
                }

            })
            .on('modal.button.miniform.build modal.button.miniform.error', function () {

                var panel = $('#modal-request-change-state');
                if (!panel.length) {
                    return;
                }

                var modReqState = $('#modal-novystav');
                if (modReqState.length) {
                    modReqState.on('change', function () {
                        Plugin_Zadost.updateStateMiniform();
                    });
                }
            })
            .on('modal.miniform.item.add.success modal.miniform.item.edit.success', function () {
                Lemo_Alert.closeById('contractFileTypeError');
                Lemo_Alert.closeById('contractFileSizeError');
            });

        var bankAccount = $('#bankovniucet');
        if (bankAccount.length) {
            Plugin_Zadost.bankAccountAutocomplete();
        }

        var titleField = $('#dotacnititul');
        if (titleField.length) {
            titleField.on('change', function () {
                Plugin_Zadost.modifyRequestValues();
            });
        }

        // aktualizace údajů žadatele
        var buttonUpdateUser = $('#button-user-update-subject');
        if (buttonUpdateUser.length) {
            buttonUpdateUser
                .off('click')
                .on('click', function (e) {
                    e.preventDefault();

                    var _ch = $('#_ch');
                    if (!_ch.length) {
                        return;
                    }

                    var url = window.location.protocol + '//' + window.location.host;
                    url += '/plugin/PluginZadost/ajaxUpdateSubject';

                    $.ajax({
                        type: 'post',
                        url: url,
                        dataType: "json",
                        global: true,
                        data: {'_ch': _ch.val()},
                        beforeSend: function () {
                            Lemo_Alert.closeAll();
                            Lemo_Alert.addInfo('Aktualizuji údaje žadatele ...', 'updateSubjectBeforeSend');
                        },
                        complete: function () {
                            Lemo_Alert.closeById('updateSubjectBeforeSend');
                        },
                        success: function (r) {

                            if (r.hasOwnProperty('messages')) {
                                Lemo_Alert.addMany(r.messages);
                            }

                            if (r.hasOwnProperty('status') && false === r.status) {
                                Lemo_Alert.addDanger('Aktualizace údajů žadatele se nezdařila', 'aktualizaceUdajuError');
                                return;
                            }

                            var data = r.data;
                            if (data.hasOwnProperty('bankovniucet')) {
                                var element = $('#bankovniucet');
                                if (element.length) {
                                    element.val(data['bankovniucet']);
                                }
                            }

                            if (data.hasOwnProperty('subject')) {
                                var select = null;
                                $.each(data['subject'], function (name, value) {
                                    var element = $('#' + name);
                                    if (element.length) {
                                        if (true === element.is('select') && value.hasOwnProperty('id')) {
                                            element.children('[value="' + value.id + '"]').attr('selected', true).prop('selected', true);
                                            select = element;
                                        } else {
                                            element.val(value);
                                        }
                                    }
                                });

                                // reload a refresh
                                DynaCore_Item.miniformReload(6, 54);
                                DynaCore_Item.miniformReload(5, 55);
                                if (null !== select) {
                                    select.trigger('change');
                                }
                            }
                        },
                        error: function () {
                            Lemo_Alert.addDanger('Aktualizace údajů žadatele selhala ...', 'updateSubjectError');
                        }
                    });
                })
        }

        // odeslání žádosti jednotlivými tlačítky
        $.each(['', '-1', '-2', '-3'], function(i, val) {
            const button = $('#button-request-send' + val);
            if (button.length) {
                button
                  .off('click')
                  .on('click', function (e) {
                      e.preventDefault();
                      Plugin_Zadost.sendRequest();
                  });
            }
        });

    },

    ajaxProgress: function (progressId) {

        $.ajax({
            type: 'post',
            url: '/plugin/PluginZadost/ajaxProgress',
            dataType: 'json',
            data: {'progressId': progressId},
            global: false,
            success: function (r) {

                if (false === r.hasOwnProperty('data')) {
                    return;
                }

                var data = r.data;
                var progressBar = $('#export-progress');
                var progressBarEta = $('#export-progress-eta');
                var progressBarMessage = $('#export-progress-message');

                if (100 === 1 * data['procent']) {
                    progressBarEta.html('Dokončeno ...');
                    window.clearInterval(Plugin_Zadost.progressInterval);
                    Plugin_Zadost.progressInterval = null;
                }
                if (progressBar.length && data['procent']) {
                    progressBar.find('.progress-bar').text(data['procent'] + '%');
                    progressBar.find('.progress-bar').css('width', data['procent'] + '%');
                }
                if (progressBarEta.length) {
                    if (null !== data['eta'] && 1 * data['procent'] < 100) {
                        progressBarEta.html('Zbývá přibližně ' + data['eta']);
                    }
                }
                if (progressBarMessage.length) {
                    if (data['messages'].length) {
                        progressBarMessage.html(data['messages'].join('<br>'));
                    }
                }
            }
        });
    },

    sendRequest: function () {
        const titul = $('#dotacnititul');
        if (titul.length && !titul.val()) {
            Lemo_Alert.addDanger('Není vybrán dotační titul', 'titulError');
            return false;
        }

        const buttonSave = $(':button[name="saveContinue"]');
        if (buttonSave.length) {
            buttonSave
                .attr('name', 'saveAndSendRequest')
                .trigger('click');
        }
    },

    bankAccountAutocomplete: function () {

        var bankAccount = $('#bankovniucet');
        if (true === bankAccount.prop('readonly') || bankAccount.prop('disabled')) {
            return;
        }

        var _ch = $('#_ch');
        if (!_ch.length) {
            return;
        }

        var url = window.location.protocol + '//' + window.location.host;
        url += '/plugin/PluginZadost/ajaxGetBankAccounts';

        bankAccount.autocomplete({
            autofocus: true,
            minLength: 0,
            global: false,
            type: 'post',
            data: {'_ch': _ch.val()},
            source: function (request, response) {
                $.ajax({
                    url: url,
                    dataType: 'json',
                    type: 'post',
                    data: {'_ch': _ch.val()},
                    success: function (r) {
                        if (r.hasOwnProperty('messages')) {
                            Lemo_Alert.addMany(r.messages);
                        }
                        if (r.hasOwnProperty('data')) {
                            if (!r.data.length) {
                                Lemo_Alert.addDanger('Nepodařilo se načíst žádný bankovní účet', 'autocomplete');
                            }
                            response(r.data);
                        }
                    }
                });
            },
            response: function (e, ui) {
                if (ui.hasOwnProperty('content') && !ui.content.length) {
                    bankAccount
                        .off('focus')
                        .autocomplete('destroy');
                }
            },
            select: function (e, ui) {
                e.preventDefault();

                if (ui.item == null) {
                    $(this).val('');
                } else {
                    $(this).val(ui.item.label);
                    $(this).blur();
                }
            }
        }).focus(function () {
            $(this).autocomplete('search', 'default');
        });
    },

    initVarianta: function () {

        var section = $('#idSection');
        if (!section.length || 103 !== parseInt(section.val())) {
            return;
        }

        var variantaField = $('#varianta');
        if (variantaField.length) {
            variantaField
              .off('change')
              .on('change', function () {
                  const castky = variantaField.data('castky');
                  if (typeof castky !== 'undefined') {
                      const pozadovanaCastka = $('#pozadovanacastka');
                      const nakladyAkce = $('#nakladyakce');
                      if (pozadovanaCastka.length) {
                          let castka = castky[variantaField.val()];
                          if (typeof castka !== "undefined") {
                              pozadovanaCastka.val(castka);
                              nakladyAkce.val(castka);
                          } else {
                              pozadovanaCastka.val('');
                              nakladyAkce.val('');
                          }
                      }
                  }
              });
        }
    },

    modifyRequestValues: function () {

        var titleField = $('#dotacnititul');
        var url = window.location.protocol + '//' + window.location.host;
        url += '/plugin/PluginZadost/ajaxModifyRequestValues';

        $.ajax({
            type: 'post',
            url: url,
            dataType: "json",
            data: titleField.serialize(),
            global: false,
            beforeSend: function () {
                Lemo_Alert.closeAll();
                Lemo_Alert.addInfo('Načítám předvyplněná pole z dotačního titulu ...', 'loadValuesFromTitleBeforeSend');
            },
            complete: function () {
                Lemo_Alert.closeById('loadValuesFromTitleBeforeSend');
            },
            success: function (r) {
                if (r.hasOwnProperty('messages')) {
                    Lemo_Alert.addMany(r.messages);
                }
                if (!r.hasOwnProperty('data')) {
                    return;
                }
                var data = r['data'];

                // select elementy
                $.each(['kategoriezadosti', 'typzadosti', 'varianta'], function (i, selectName) {
                    if (!data.hasOwnProperty(selectName)) {
                        return true;
                    }
                    var field = $('#' + selectName);
                    if (!field.length || false === field.is('select')) {
                        return true;
                    }
                    var options = field.children();
                    if (!options.length) {
                        return true;
                    }

                    options.remove();
                    $.each(data[selectName], function (i, val) {
                        $(field).append($('<option>', {
                            value: val.id,
                            text: val.label
                        }));
                    });

                    if ('varianta' === selectName && data.hasOwnProperty('variantyCastky')) {
                        $(field).data('castky', data['variantyCastky']);
                    }
                });

                // prevyplnena pole z titulu
                if (data.hasOwnProperty('vyplnit')) {
                    $.each(data['vyplnit'], function (name, value) {
                        var element = $('#' + name);
                        if (!element.length) {
                            return true;
                        }
                        element.val(value);
                    });
                }

                if (data.hasOwnProperty('souhlas')) {
                    let text = $(document.querySelector('[data-id="text-1"]'));
                    if (text.length) {
                        text.html(data['souhlas']);
                    }
                }
            }
        });
    },

    updateStateMiniform: function () {
        const stavZadosti = $('#modal-novystav');
        if (!stavZadosti.length) {
            return;
        }

        // odstranění class a skrytí elementů
        var elements = [
            "datumdoporuceni",
            "castkakomise",
            "schvalenacastka",
            "typusneseni",
            "cislousneseni",
            "spisovaznacka",
            "uzavritdokument",
            "datumpodpisusmlouvy",
            "evidencnicislokontroly",
        ];

        $.each(elements, function (i, name) {
            var formGroup = $('#form-group-modal-' + name);
            if (formGroup.length) {
                formGroup.addClass('d-none');
            }
        });

        // doporučeno komisí
        if (6 === parseInt(stavZadosti.val())) {
            elements = ['datumdoporuceni', 'castkakomise'];
            $.each(elements, function (i, name) {
                var formGroup = $('#form-group-modal-' + name);
                if (formGroup.length) {
                    formGroup.removeClass('d-none');
                }
            });
        }

        // schváleno
        if (8 === parseInt(stavZadosti.val())) {
            elements = ['schvalenacastka', 'typusneseni', 'cislousneseni'];
            $.each(elements, function (i, name) {
                var formGroup = $('#form-group-modal-' + name);
                if (formGroup.length) {
                    formGroup.removeClass('d-none');
                }
            });
        }

        // smlouva uzavřena
        if (9 === parseInt(stavZadosti.val())) {
            elements = ['datumpodpisusmlouvy'];
            $.each(elements, function (i, name) {
                var formGroup = $('#form-group-modal-' + name);
                if (formGroup.length) {
                    formGroup.removeClass('d-none');
                }
            });
        }

        // ukonceno s kontrolou
        if (23 === parseInt(stavZadosti.val())) {
            elements = ['evidencnicislokontroly'];
            $.each(elements, function (i, name) {
                var formGroup = $('#form-group-modal-' + name);
                if (formGroup.length) {
                    formGroup.removeClass('d-none');
                }
            });
        }

        // nastaveni povinne poznamky
        var element = $('#form-group-modal-poznamka');
        if (element.length) {
            // em element
            var em = element.find('em.required');
            if (!em.length) {
                var label = element.find('label');
                label.append('&nbsp;<em class="required d-none">*</em>');
                em = element.find('em.required');
            }

            if (true === Plugin_Zadost.isCommentRequired(stavZadosti.val())) {
                em.removeClass('d-none');
            } else {
                em.addClass('d-none');
            }

            if (element.hasClass('has-error')) {
                element.removeClass('has-error');
                var hb = element.find('.help-block');
                if (hb.length) {
                    hb.remove();
                }
            }
        }

        // nastaveni spisove znacky
        var spisovaZnacka = $('#form-group-modal-spisovaznacka');
        var uzavritDokument = $('#form-group-modal-uzavritdokument');
        if (spisovaZnacka.length && uzavritDokument.length) {

            if (true === Plugin_Zadost.sendInState(stavZadosti.val())) {
                spisovaZnacka.removeClass('d-none');
                uzavritDokument.removeClass('d-none');
            } else {
                spisovaZnacka.addClass('d-none');
                uzavritDokument.addClass('d-none');
            }

            if (spisovaZnacka.hasClass('has-error')) {
                spisovaZnacka.removeClass('has-error');
                hb = spisovaZnacka.find('.help-block');
                if (hb.length) {
                    hb.remove();
                }
            }
        }
    },

    isCommentRequired: function (idState) {
        var result = false;
        if (!idState.length) {
            return result;
        }

        var element = $('#modal-poznamka');
        if (!element.length) {
            return result;
        }

        var data = element.data('stavy-povinna-poznamka');
        if (typeof data === 'undefined' || !data.length) {
            return result;
        }

        $.each(data.split('|'), function (i, st) {
            if (parseInt(idState) === parseInt(st)) {
                result = true;
                return false;
            }
        });

        return result;
    },

    sendInState: function (idState) {
        let result = false;
        if (!idState.length) {
            return result;
        }

        var element = $('#modal-spisovaznacka');
        if (!element.length) {
            return result;
        }

        var data = element.data('stavy-athena-odeslat');
        if (typeof data === 'undefined' || !data.length) {
            return result;
        }

        $.each(data.split('|'), function (i, st) {
            if (parseInt(idState) === parseInt(st)) {
                result = true;
                return false;
            }
        });

        return result;
    }
};

$(document)
    .ready(function (){
        Plugin_Zadost.init();
        Plugin_Zadost.initVarianta();
    });
